import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import {
	Theme,
	createStyles,
	WithStyles,
	withStyles,
	Grid,
	Typography,
	Button,
} from '@material-ui/core';
import { NavigateBeforeOutlined as BackIcon } from '@material-ui/icons';
import { SearchField } from '../../common';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import ACLService from '../../acl/services/aclService';

const styles = (theme: Theme) =>
  createStyles({
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },

    headerRoot: {
      backgroundColor: "white",
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
    },

    backLink: {
      textDecoration: "none",
    },
    backIconRoot: {
      fill: theme.palette.text.secondary,
      fontSize: 24,
      opacity: 0.5,
      marginBottom: 3,
    },
    searchBox: {
      background: "#FFFFFF",
      border: "1px solid #D4D4D4",
      boxSizing: "border-box",
      borderRadius: 5,
      width: 273,
      padding: "0px 8px",
    },
    infoIcon: {
      "&>span": {
        "&>:nth-child(2)": {
          top: "24px",
        },
      },
    },
  });

interface TagManagementHeaderProps extends WithStyles<typeof styles> {
	searchValue: string,
	searchChangeHandler: () => void,
	addTagHandler: () => void,
}

const TagManagementHeader = (props: TagManagementHeaderProps) => {
	const {
		classes,
		searchChangeHandler,
		searchValue,
		addTagHandler,
	} = props;
	let courseCheck = (window.location.href).split("?")

	return (
		<Grid
			className={`${classes.headerRoot} ${classes.mb2x}`}
			container justify="space-between" alignItems="center">
			<Grid item xs="auto">
				{
					courseCheck.length == 2
						?
						<Link to="/course" className={classes.backLink}>
							<Typography color="textPrimary" variant="subtitle1">
								<BackIcon classes={{ root: classes.backIconRoot }} />
								<strong>Back to Course</strong>
							</Typography>
						</Link>
						:
						<Link to="/mylibrary" className={classes.backLink}>
							<Typography color="textPrimary" variant="subtitle1">
								<BackIcon classes={{ root: classes.backIconRoot }} />
								<strong>Back to Dashboard</strong>
							</Typography>
						</Link>
				}


			</Grid>

			<Grid item xs={9}>
				<SearchField
					id="tag-management-search"
					placeholder="Search tags"
					onChange={searchChangeHandler}
					value={searchValue}
					className={classes.searchBox}
					fullWidth
				/>
			</Grid>

			<Grid item xs="auto">
				<Button
				    disabled={!ACLService.checkModulePermission("tag", "createOptional")}
					variant="contained"
					color="primary"
					onClick={addTagHandler}>
					Add Tag
				</Button>
				<span className={classes.infoIcon}>
					<CustomInfoIcon
						infoDialogContentType="filters"
						isInfoIcon={true}
						isRightArrow={true}
						isCenterArrow={false}
						knowMoreAbout={false}
						dialogTitle="Add Custom Tag"
						imageURL="/assets/svg/infoIcon/tagManagement/addTag.svg"
						dialogPara="You can create any custom tag by selecting the type of tag from the various options available. This will also reflect in content as per the settings."
						details="Click to know more"
						toolTipDirection="top" />
					</span>
			</Grid>
		</Grid>
	);
};

export default withStyles(styles)(TagManagementHeader);